"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useActivities;

var _WebChatReduxContext = require("./internal/WebChatReduxContext");

function useActivities() {
  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var activities = _ref.activities;
    return activities;
  })];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VBY3Rpdml0aWVzLnRzIl0sIm5hbWVzIjpbInVzZUFjdGl2aXRpZXMiLCJhY3Rpdml0aWVzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBRUE7O0FBRWUsU0FBU0EsYUFBVCxHQUFpRDtBQUM5RCxTQUFPLENBQUMsc0NBQVk7QUFBQSxRQUFHQyxVQUFILFFBQUdBLFVBQUg7QUFBQSxXQUFvQkEsVUFBcEI7QUFBQSxHQUFaLENBQUQsQ0FBUDtBQUNEIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBEaXJlY3RMaW5lQWN0aXZpdHkgfSBmcm9tICdib3RmcmFtZXdvcmstd2ViY2hhdC1jb3JlJztcblxuaW1wb3J0IHsgdXNlU2VsZWN0b3IgfSBmcm9tICcuL2ludGVybmFsL1dlYkNoYXRSZWR1eENvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VBY3Rpdml0aWVzKCk6IFtEaXJlY3RMaW5lQWN0aXZpdHlbXV0ge1xuICByZXR1cm4gW3VzZVNlbGVjdG9yKCh7IGFjdGl2aXRpZXMgfSkgPT4gYWN0aXZpdGllcyldO1xufVxuIl19